module.exports = __webpack_public_path__ + "img/shm_logo_Login.a403a919.svg";